import { DW_WW_LOGO_URL } from '@lib/config'
import { keyframes } from '@mui/material'
import Box from '@mui/material/Box'

const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.1);
  }
  100% {
    box-shadow: 0 0 0 8px rgba(0, 0, 0, 0);
  }
`

function LoadingAnimation() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '50%',
          padding: '1rem',
          animation: `${pulseAnimation} 1s infinite`,
        }}
      >
        <Box
          component='img'
          src={DW_WW_LOGO_URL}
          alt='🪷'
          loading='eager'
          sx={{
            width: '100px',
            height: '100px',
          }}
        />
      </Box>
    </Box>
  )
}

export default LoadingAnimation
